import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { data } from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { fuenteI } from 'src/app/modelos/fuentes.interface';
import { OperacionI } from 'src/app/modelos/operacionEsta.interface';
import { ResponseLDAPI } from 'src/app/modelos/responseLDAP';
import { UsuarioI } from 'src/app/modelos/usuario.interface';
import { nuevousuariodto } from 'src/app/modelos/usuarios/nuevousuariodto';
import { CargandoService } from 'src/app/plantillas/cargando/cargando.service';
import { AlertasService } from 'src/app/servicios/alertas/alertas.service';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import { UsuariosServiceService } from 'src/app/servicios/usuarios/UsuariosService.service';

@Component({
  selector: 'app-usuariodane',
  templateUrl: './usuariodane.component.html',
  styleUrls: ['./usuariodane.component.css']
})
export class UsuariodaneComponent implements OnInit {

  btnguardar : Boolean;
  camposDis : Boolean;
  buscarUsuario: String;
  nombre : string;
  identificaacion : string;
  correo : string;
  telefono : string;
  extencion : string;
  cargo : string;

  ConsultaLDAP : ResponseLDAPI;
  NuevoDANE : UsuarioI;

  //buscarUsuario = new FormControl('',[Validators.required]);
  /*nombre = new FormControl('',[Validators.required]);
  identificaacion = new FormControl('',[Validators.required]);
  correo = new FormControl('',[Validators.required]);
  telefono = new FormControl('',[Validators.required]);
  extencion = new FormControl('',[Validators.required]);
  cargo = new FormControl('',[Validators.required]);*/

  @ViewChild('openmodalcargando') openmodalcargando: ElementRef;
  @ViewChild('closemodacargando') closemodacargando: ElementRef;

  NuevoUsario: nuevousuariodto= new nuevousuariodto;
  rol= new FormControl(null,[Validators.required]);
  usuario= new FormControl(null,[Validators.required]);
  tipodocumento= new FormControl('',[Validators.required]);
	numerodocumento= new FormControl('',[Validators.required, Validators.pattern('[0-9 ]*')]);
	nombres= new FormControl('',[Validators.required]);
	apellidos= new FormControl('',[Validators.required]);
	correousuario= new FormControl('',[Validators.required, Validators.email]);
  correousuario1= new FormControl('',[Validators.required, Validators.email]);
	telefonousuario= new FormControl('',[Validators.required, Validators.pattern('[0-9 ]*')]);
	extencionusuario= new FormControl('',[Validators.required, Validators.pattern('[0-9 ]*')]);
	cargousuario= new FormControl('',[Validators.required]);
  username : string;
  correoCoincide: Boolean;

  constructor(
    private api:ApiService,
    private loadingService: CargandoService,
    private router:Router,
    private alerta:AlertasService,
    private appService:AppServiceService,
    private toastr: ToastrService,
    private usuarioService: UsuariosServiceService
  ) { }

  ngOnInit(): void {
    this.ConsultaLDAP = new ResponseLDAPI;
    this.NuevoDANE = new UsuarioI;
    this.camposDis = false;
    this.btnguardar = false;
    this.correoCoincide = true;
    this.telefono = "";
    this.extencion = "";
    this.cargo = "";
  }

  Update(){
    this.NuevoUsario.rol = this.rol.value;
    this.NuevoUsario.usuario = this.usuario.value;
    this.NuevoUsario.tipodocumento = this.tipodocumento.value;
    this.NuevoUsario.numerodocumento = this.numerodocumento.value;
    this.NuevoUsario.nombres = this.nombres.value;
    this.NuevoUsario.apellidos = this.apellidos.value;
    this.NuevoUsario.correo = this.correousuario.value;
    this.NuevoUsario.telefono = this.telefonousuario.value;
    this.NuevoUsario.extencion = this.extencionusuario.value;
    this.NuevoUsario.cargo = this.cargousuario.value;
  }

  VerificarCorreo(){
    if(this.correousuario.value!=this.correousuario1.value) {
      this.toastr.warning('El correo no coincide.', 'Advertencia!');
      this.correoCoincide = false;
    }else{
      this.correoCoincide = true;
    }
  }

  checkEmailValidity() {
    const atIndex = this.correousuario.value.indexOf('@');
    if (atIndex !== -1) {
      const domain = this.correousuario.value.substring(atIndex + 1);
      if (domain.indexOf('.') !== -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  VerificarCampos(){
    if(this.rol.hasError('required')) this.toastr.warning('Seleccionar el perfil.', 'Advertencia!');
    else if(this.tipodocumento.hasError('required')) this.toastr.warning('Seleccionar tipo de documento.', 'Advertencia!');
    else if(this.numerodocumento.hasError('required')) this.toastr.warning('Ingrese número de domcumento.', 'Advertencia!');
    else if(this.numerodocumento.hasError('pattern')) this.toastr.warning('El número de identificación contiene caracteres no permitidos.', 'Advertencia!');
    else if(this.numerodocumento.value.length < 6) this.toastr.warning('El número de identificación debe contar con mínimo 6 caracteres.', 'Advertencia!');
    else if(this.numerodocumento.value.length > 10) this.toastr.warning('El número de identificación debe contar con máximo 10 caracteres.', 'Advertencia!');
    else if(this.nombres.hasError('required')) this.toastr.warning('Ingrese nombres.', 'Advertencia!');
    else if(this.nombres.value.length < 4) this.toastr.warning('El nombre del responsable debe contar con mínimo 6 caracteres.', 'Advertencia!');
    else if(this.nombres.value.length > 100) this.toastr.warning('El nombre del responsable debe contar con máximo 100 caracteres.', 'Advertencia!');
    else if(this.apellidos.hasError('required')) this.toastr.warning('Ingrese apellidos.', 'Advertencia!');
    else if(this.apellidos.value.length < 4) this.toastr.warning('Los apellidos del responsable debe contar con mínimo 6 caracteres.', 'Advertencia!');
    else if(this.apellidos.value.length > 100) this.toastr.warning('Los apellidos del responsable debe contar con máximo 100 caracteres.', 'Advertencia!');
    else if(this.correousuario.hasError('required')) this.toastr.warning('Ingrese correo.', 'Advertencia!');
    else if(this.correousuario.hasError('email')) this.toastr.warning('Correo no valido.', 'Advertencia!');
    else if(this.correousuario.value.length < 10) this.toastr.warning('Correo debe tener mínimo 10 caracteres.', 'Advertencia!');
    else if(this.correousuario.value.length > 40) this.toastr.warning('Correo debe tener máximo 40 caracteres.', 'Advertencia!');
    else if(this.correousuario1.hasError('required')) this.toastr.warning('Confirmar correo.', 'Advertencia!');
    else if(this.correousuario1.hasError('email')) this.toastr.warning('Confirmar correo no valido.', 'Advertencia!');
    else if(this.correousuario1.value.length < 10) this.toastr.warning('Confirmar correo debe tener mínimo 10 caracteres.', 'Advertencia!');
    else if(this.correousuario1.value.length > 40) this.toastr.warning('Confirmar correo debe tener máximo 40 caracteres.', 'Advertencia!');
    else if(this.correousuario.value!=this.correousuario1.value) this.toastr.warning('El correo no coincide.', 'Advertencia!');
    else if(this.telefonousuario.hasError('required')) this.toastr.warning('Ingrese télefono.', 'Advertencia!');
    else if(this.telefonousuario.hasError('pattern')) this.toastr.warning('Télefono tiene caracteres no validos.', 'Advertencia!');
    else if(this.telefonousuario.value.length < 7) this.toastr.warning('Teléfono debe tener mínimo 7 caracteres.', 'Advertencia!');
    else if(this.telefonousuario.value.length > 10) this.toastr.warning('Teléfono debe tener máximo 10 caracteres.', 'Advertencia!');
    else if(this.extencionusuario.hasError('required')) this.toastr.warning('Ingrese extención.', 'Advertencia!');
    else if(this.extencionusuario.hasError('pattern')) this.toastr.warning('Extención tiene caracteres no validos.', 'Advertencia!');
    else if(this.extencionusuario.value.length < 2) this.toastr.warning('Extención debe tener mínimo 2 caracteres.', 'Advertencia!');
    else if(this.extencionusuario.value.length > 5) this.toastr.warning('Extención debe tener máximo 5 caracteres.', 'Advertencia!');
    else if(this.cargousuario.hasError('required')) this.toastr.warning('Ingrese cargo.', 'Advertencia!');
    else if(this.cargousuario.value.length < 5) this.toastr.warning('Cargo debe tener mínimo 5 caracteres.', 'Advertencia!');
    else if(this.cargousuario.value.length > 20) this.toastr.warning('Cargo debe tener máximo 20 caracteres.', 'Advertencia!');
  }

  BTNguardar(){
    if(this.rol.hasError('required')||this.tipodocumento.hasError('required')||this.numerodocumento.hasError('required')||
    this.numerodocumento.hasError('pattern')||this.numerodocumento.value.length < 6||this.numerodocumento.value.length > 10||
    this.nombres.hasError('required')||this.nombres.value.length < 6||this.apellidos.hasError('required')||
    this.apellidos.value.length < 6||this.correousuario.hasError('required')||this.correousuario.hasError('email')||
    (this.correousuario.value!=this.correousuario1.value)||!this.checkEmailValidity()||this.telefonousuario.hasError('required')||
    this.telefonousuario.hasError('pattern')||this.telefonousuario.value.length < 7||this.telefonousuario.value.length > 10||
    this.extencionusuario.hasError('required')||this.extencionusuario.hasError('pattern')||this.extencionusuario.value.length < 2||
    this.extencionusuario.value.length > 5||this.cargousuario.hasError('required')||this.cargousuario.value.length < 5||
    this.cargousuario.value.length > 20
    ){
      return true;
    }else {
      return false;
    }
  }

  BuscarUsuario(){//buscarUsuario
    this.username = "";
    this.usuarioService.consecutivoUsuario().subscribe(result=>{
      this.username = ""+result;
      if(this.username.length == 1) this.username = "0000".concat(result);
      else if(this.username.length == 2) this.username = "000".concat(result);
      else if(this.username.length == 3) this.username = "00".concat(result);
      else if(this.username.length == 4) this.username = "0".concat(result);
      if(this.rol.value==1){
        this.usuario.setValue("AD".concat(this.username))
        this.Update();
      }else if(this.rol.value==2){
        this.usuario.setValue("TE".concat(this.username))
        this.Update();
      }else if(this.rol.value==3){
        this.usuario.setValue("OP".concat(this.username));
        this.Update();
      }
    });
  }

  GuardarNuevoUsuario(){
    this.btnguardar = true;
    //console.log(this.NuevoUsario);
    this.usuarioService.nuevoUsuarioDane(this.NuevoUsario).subscribe(result=>{
      if(result == true ){
        this.toastr.success('Usuario creado.', 'OK!');
        this.router.navigate(['usuarios']);
      }else {
        this.toastr.error('Error al crear usuario', 'Error!');
        this.btnguardar = false;
      }
    }, error =>{
      this.closemodacargando.nativeElement.click();
      this.toastr.error('Error al crear usuario', 'Error!');
      this.btnguardar = false;
    });
  }

  regresar(){
    this.router.navigate(['usuarios']);
  }

}
